import React from "react";

const LogoutIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.2 2H9.8C13 2 15 4 15 7.2V11.25H8.75C8.34 11.25 8 11.59 8 12C8 12.41 8.34 12.75 8.75 12.75H15V16.8C15 20 13 22 9.8 22H7.21C4.01 22 2.01 20 2.01 16.8V7.2C2 4 4 2 7.2 2Z"
        fill="#FF4536"
      />
      <path
        d="M19.4396 11.25L17.3696 9.18003C17.2196 9.03003 17.1496 8.84003 17.1496 8.65003C17.1496 8.46003 17.2196 8.26003 17.3696 8.12003C17.6596 7.83003 18.1396 7.83003 18.4296 8.12003L21.7796 11.47C22.0696 11.76 22.0696 12.24 21.7796 12.53L18.4296 15.88C18.1396 16.17 17.6596 16.17 17.3696 15.88C17.0796 15.59 17.0796 15.11 17.3696 14.82L19.4396 12.75H14.9996V11.25H19.4396Z"
        fill="#FF4536"
      />
    </svg>
  );
};

export default LogoutIcon;
